import React from 'react';

const EmailKPIs = ({ emailStats, isDark }) => {
  if (!emailStats) return null;

  const stats = [
    {
      label: 'Total Emails Sent',
      value: emailStats.totalEmails || 0,
      icon: '/assets/icons/emails.svg',
      color: isDark ? '#cd6d2c' : '#cd6d2c'
    },
    {
      label: 'Seen Emails',
      value: emailStats.seenEmails || 0,
      icon: '/assets/icons/seenemails.svg',
      color: isDark ? '#00A86B' : '#00A86B'
    },
    {
      label: 'Unseen Emails',
      value: emailStats.unseenEmails || 0,
      icon: '/assets/icons/unseenemails.svg',
      color: isDark ? '#9A7B00' : '#9A7B00'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-[16px] sm:gap-[20px] w-full">
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`border-solid border-[1px] rounded-[16px] sm:rounded-[24px] p-[16px] sm:p-[20px] flex items-center justify-between transition-colors duration-200 ${
            isDark ? 'bg-[#161515] border-[#292929]' : 'bg-white border-[#d9d9d9]'
          }`}
        >
          <div className="flex flex-col items-start gap-[8px]">
            <div
              className="w-[24px] h-[24px]"
              style={{
                backgroundColor: stat.color,
                WebkitMaskImage: `url('${stat.icon}')`,
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskSize: 'contain',
                WebkitMaskPosition: 'center',
                maskImage: `url('${stat.icon}')`,
                maskRepeat: 'no-repeat',
                maskSize: 'contain',
                maskPosition: 'center',
              }}
              aria-hidden="true"
            />
            <span className={`text-[14px] sm:text-[16px] font-medium transition-colors duration-200 ${
              isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
            }`}>
              {stat.label}
            </span>
          </div>
          <div
            className="text-[20px] sm:text-[20px] font-bold transition-colors duration-200"
            style={{ color: stat.color }}
          >
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmailKPIs;